export enum BlockType {
  Paragraph = 'paragraph',
  Mention = 'mention',
  Emoticon = 'emoticon',
  Link = 'link',
  Command = 'command',
}
